export default "__VITE_ASSET__CaOQjR$6__"